module.exports = __webpack_public_path__ + "static/img/icon_ban.d0289dc0.png";